    <div class="sidenav" *ngIf="isDesktop">
        <a class="link" routerLinkActive="active" routerLink="/contact">Contact</a>
      </div>
      <div class="ipad-sidenav" *ngIf="isIpad">
        <a class="link" routerLinkActive="active" routerLink="/contact">Contact</a>
      </div>  

      <div class="dropdown" style="float:right;" *ngIf="isMobile" >
        <div class="menu-icon">&#9776;
        </div>
      <div class="mobile-sidenav" >
        <a class="link" routerLinkActive="active" routerLink="/contact">Contact</a>
      </div>
    </div>
      